/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";
import { generateRandomString } from "helper/Common/CommonHelper";
import { reactSelectStyle } from "Config/Config";

const AddUpdateQuestionPopup = ({
  questionTypes,
  afterPopupClose,
  selectedQuestionId,
  setSelectedQuestionId,
}) => {
  const token = localStorage.getItem("token");
  const params = useParams();
  const { t } = useTranslation(); //for translation

  /* question type selected  */
  const [selectedQuestionType, setSelectedQuestionType] = useState(null);
  const [questionTypeSelectedValue, setQuestionTypeSelectedValue] =
    useState(null);
  const [showOptionalAnswerBlock, setShowOptionalAnswerBlock] = useState(false);
  const [code, setcode] = useState("");
  const [question, setQuestion] = useState("");
  const [correctAnswer, setcorrectAnswer] = useState("");
  const [order, setorder] = useState(1);

  // options answers
  const [answerOptions, setAnswerOptions] = useState([]);
  const [optionalAnswer, setOptionalAnswer] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  const [errors, setErrors] = useState({});

  // function for check validation
  const validateForm = () => {
    const newErrors = {};

    if (!selectedQuestionType) {
      newErrors.questionType = t(
        "Please select a question format from the list."
      );
    }

    if (!question.trim()) {
      newErrors.question = t("Please enter the text for your question.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get question details
  const getquestionDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_QUESTION_DETAILS +
        `/${selectedQuestionId}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const data = response.data;
        questionTypeSelectionHandler(data.questiontype);
        setcode(data.code);
        setQuestion(data.name);
        setorder(data.rank);
        setcorrectAnswer(data.correctanswer);
        optionalAnswerHandler(data.answers);
      }

      console.log(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for select question type
  const questionTypeSelectionHandler = (val) => {
    if (val) {
      setQuestionTypeSelectedValue(val);
      setSelectedQuestionType(val.value);

      if (val.label == "Single Select" || val.label == "Multi Select") {
        setShowOptionalAnswerBlock(true);
      } else {
        setShowOptionalAnswerBlock(false);
      }
    } else {
      setQuestionTypeSelectedValue(null);
      setSelectedQuestionType(null);
    }
  };

  //function for select optional answer
  const optionalAnswerHandler = (val) => {
    setOptionalAnswer(val);
    const answerList = val.map((answer) => answer.value);
    setAnswerOptions(answerList);
  };

  //function for reset
  const resetHandler = () => {
    setQuestion("");
    // setcode("");
    setcorrectAnswer("");
    setorder(1);
    setSelectedQuestionType(null);
    setQuestionTypeSelectedValue(null);
    setAnswerOptions([]);
    setOptionalAnswer(null);
    setSelectedQuestionId(null);
    setShowOptionalAnswerBlock(false);

    const randomString = generateRandomString(4);
    setcode(`Q - ${randomString}`);

    setErrors({});
  };

  //function for save question
  const saveQuestionHandler = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSaving(true);

    try {
      let questionData = {
        questiontype: selectedQuestionType,
        surveyid: params.id,
        code,
        name: question,
        correctanswer: correctAnswer,
        answers: answerOptions,
        rank: order,
      };
      console.log("Question data=======>", questionData);

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (selectedQuestionId) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_QUESTION +
          `/${selectedQuestionId}` +
          ``;

        response = await putData(requestUrl, questionData);
      } else {
        requestUrl =
          requestUrl + url.API_ADD_QUESTION_TO_SURVEY;

        response = await postData(requestUrl, questionData);
      }

      setIsSaving(false);

      if (response.status) {
        resetHandler();
        afterPopupClose();

        bootstrap.Offcanvas.getInstance(
          document.querySelector("#offcanvasSurveyQuestion")
        ).hide();
      }
    } catch (error) {
      console.log("error", error.message);
    }
  };

  useEffect(() => {
    if (selectedQuestionId) {
      getquestionDetails();
    }
  }, [selectedQuestionId]);

  useEffect(() => {
    const randomString = generateRandomString(4);
    setcode(`Q - ${randomString}`);
  }, []);

  // Custom styles for members
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.questionType ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.questionType ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasSurveyQuestion"
      aria-labelledby="offcanvasAddSurveyLabel"
    >
      {/* -- Offcanvas Header with Title -- */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              quiz
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasAddSurveyLabel"
            >
              {selectedQuestionId ? t("Edit Question") : t("Add New Question")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {selectedQuestionId
                ? t("Manage existing question details")
                : t("Define a new question")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      {/* -- Offcanvas Body -- */}
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            {/* -- Form Fields Container (allows scrolling while footer stays fixed) -- */}
            <div className="flex-grow-1 fields-container">
              {/* -- Question Type -- */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="questionType"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Question Type")} <span className="text-danger">*</span>
                </label>
                <Select
                  id="questionType"
                  isClearable
                  styles={customStyles}
                  placeholder={t(
                    "Choose a format (e.g., Text, Multiple Choice)"
                  )}
                  options={questionTypes}
                  value={questionTypeSelectedValue}
                  onChange={(val) => {
                    questionTypeSelectionHandler(val);
                    if (errors.questionType) {
                      setErrors((prev) => ({ ...prev, questionType: "" }));
                    }
                  }}
                />
                {errors.questionType && (
                  <div className="invalid-feedback d-block mt-1">
                    {errors.questionType}
                  </div>
                )}
              </div>

              {/* -- Question to be asked -- */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="questionText"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Question to be asked")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  id="questionText"
                  type="text"
                  className={`form-control fs-sm shadow-none ${
                    errors.question ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t(
                    "e.g., How would you rate our customer service?"
                  )}
                  value={question}
                  onChange={(e) => {
                    setQuestion(e.target.value);
                    setErrors((prevState) => ({
                      ...prevState,
                      question: false,
                    }));
                  }}
                />
                {errors.question && (
                  <div className="invalid-feedback d-block mt-1">
                    {errors.question}
                  </div>
                )}
              </div>

              {/* -- Optional Answers (Visually Grouped) -- */}
              {showOptionalAnswerBlock && (
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label
                    htmlFor="optionalAnswers"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Optional Answers")}
                    <small className="d-block text-muted fw-normal mt-1">
                      {t(
                        "Provide choices for Single or Multi Select questions."
                      )}
                    </small>
                  </label>
                  <CreatableSelect
                    id="optionalAnswers"
                    isClearable
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    isMulti
                    placeholder={t("Type an answer and press Enter to add it")}
                    value={optionalAnswer}
                    onChange={(val) => optionalAnswerHandler(val)}
                  />
                </div>
              )}

              {/* -- Correct Answers -- */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="correctAnswer"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Correct Answers")}
                </label>
                <textarea
                  id="correctAnswer"
                  name="correctAnswer"
                  cols="30"
                  rows="4"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t(
                    "Provide the correct answer(s) here for reference or scoring."
                  )}
                  value={correctAnswer}
                  onChange={(e) => setcorrectAnswer(e.target.value)}
                ></textarea>
              </div>

              {/* -- Code & Order (in a row for better layout) -- */}
              <div className="row mb-4 p-3 border rounded-8 shadow-sm bg-white mx-0">
                <div className="col-6 ps-0">
                  <label
                    htmlFor="code"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Code")}
                  </label>
                  <input
                    id="code"
                    type="text"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder={t("e.g., Q-A1B2")}
                    value={code}
                    onChange={(e) => setcode(e.target.value)}
                  />
                </div>
                <div className="col-6 pe-0">
                  <label
                    htmlFor="order"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Order")}
                  </label>
                  <input
                    id="order"
                    type="number"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder={t("e.g., 1")}
                    value={order}
                    onChange={(e) => setorder(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* -- Action Buttons Footer -- */}
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveQuestionHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Question")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUpdateQuestionPopup;
